export default "__VITE_ASSET__CEoEytoW__"